const routes = {
  home: '/',
  balance: '/balance',
  report: '/report',
  developers: '/developers',
  googleAuthorized: '/googleauthorized',
};
export default routes;
